import apiClient from './apiClient'


const getSettings = (tenant) => {
  return apiClient.get(`/${tenant}/Settings`)
}

const updateSettings = (tenant, settings) => {
  return apiClient.put(`/${tenant}/Settings`, settings)
}


export default {
  getSettings,
  updateSettings
}
